export const ExpiringFansTableSkeleton = () => {
  return (
    <div className="w-full">
      <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between ">
        <div className="h-[32px] w-[204px] flex-shrink-0 animate-pulse rounded-lg bg-skeleton">
          &nbsp;
        </div>
        <div className="flex gap-2">
          <div className="h-[42px] w-[214px] flex-shrink-0 animate-pulse rounded-lg bg-skeleton md:ml-auto">
            &nbsp;
          </div>
          <div className="h-[42px] w-[214px] flex-shrink-0 animate-pulse rounded-lg bg-skeleton md:ml-auto">
            &nbsp;
          </div>
        </div>
      </div>
      <div className="mt-2 h-[500px] w-full animate-pulse rounded-md bg-skeleton" />
    </div>
  )
}
